module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-17-bb28764d7c0552441207466c817dfe75.jpg";